import { MODIFICATION_TYPE, NAME_OF_PRODUCT_TYPES } from "./sf_constants"

export const HOURS_OF_DAY_LABEL_VALUES = {
    h0: "12am",
    h1: "1am",
    h2: "2am",
    h3: "3am",
    h4: "4am",
    h5: "5am",
    h6: "6am",
    h7: "7am",
    h8: "8am",
    h9: "9am",
    h10: "10am",
    h11: "11am",
    h12: "12pm",
    h13: "1pm",
    h14: "2pm",
    h15: "3pm",
    h16: "4pm",
    h17: "5pm",
    h18: "6pm",
    h19: "7pm",
    h20: "8pm",
    h21: "9pm",
    h22: "10pm",
    h23: "11pm",
}

export const HOURS_OF_DAY_WITH_DEFAULT_BID = {
    h0: 100,
    h1: 100,
    h2: 100,
    h3: 100,
    h4: 100,
    h5: 100,
    h6: 100,
    h7: 100,
    h8: 100,
    h9: 100,
    h10: 100,
    h11: 100,
    h12: 100,
    h13: 100,
    h14: 100,
    h15: 100,
    h16: 100,
    h17: 100,
    h18: 100,
    h19: 100,
    h20: 100,
    h21: 100,
    h22: 100,
    h23: 100
}

export const DAY_ARRARY = [
    {
        name: 'monday',
        day_id: 1,
        value: ''
    },
    {
        name: 'tuesday',
        day_id: 2,
        value: ''
    },
    {
        name: 'wednesday',
        day_id: 3,
        value: ''
    },
    {
        name: 'thursday',
        day_id: 4,
        value: ''
    },
    {
        name: 'friday',
        day_id: 5,
        value: ''
    },
    {
        name: 'saturday',
        day_id: 6,
        value: ''
    },
    {
        name: 'sunday',
        day_id: 0,
        value: ''
    }
]

// In the UI, we show Monday first but in the US,
// Sunday is the first day of the week, hence the id 0 for Sunday
export const DAY = {
    MONDAY: {
        name: 'monday',
        id: 1
    },
    TUESDAY: {
        name: 'tuesday',
        id: 2
    },
    WEDNESDAY: {
        name: 'wednesday',
        id: 3
    },
    THURSDAY: {
        name: 'thursday',
        id: 4
    },
    FRIDAY: {
        name: 'friday',
        id: 5
    },
    SATURDAY: {
        name: 'saturday',
        id: 6
    },
    SUNDAY: {
        name: 'sunday',
        id: 0
    }
}

export const DAY_SEQUENCE = [
    DAY.MONDAY,
    DAY.TUESDAY,
    DAY.WEDNESDAY,
    DAY.THURSDAY,
    DAY.FRIDAY,
    DAY.SATURDAY,
    DAY.SUNDAY
]

export const DEFAULT_CAMPAIGN_SCHEDULE_DATA = [
    {
        modification_type: MODIFICATION_TYPE.new,
        day_id: 0,
        active: true,
        ...HOURS_OF_DAY_WITH_DEFAULT_BID
    },
    {
        modification_type: MODIFICATION_TYPE.new,
        day_id: 1,
        active: true,
        ...HOURS_OF_DAY_WITH_DEFAULT_BID
    },
    {
        modification_type: MODIFICATION_TYPE.new,
        day_id: 2,
        active: true,
        ...HOURS_OF_DAY_WITH_DEFAULT_BID
    },
    {
        modification_type: MODIFICATION_TYPE.new,
        day_id: 3,
        active: true,
        ...HOURS_OF_DAY_WITH_DEFAULT_BID
    },
    {
        modification_type: MODIFICATION_TYPE.new,
        day_id: 4,
        active: true,
        ...HOURS_OF_DAY_WITH_DEFAULT_BID
    },
    {
        modification_type: MODIFICATION_TYPE.new,
        day_id: 5,
        active: true,
        ...HOURS_OF_DAY_WITH_DEFAULT_BID
    },
    {
        modification_type: MODIFICATION_TYPE.new,
        day_id: 6,
        active: true,
        ...HOURS_OF_DAY_WITH_DEFAULT_BID
    },
]

export const CopyCurrentDayOptions = [{
    options: [
        {
            value: [DAY.MONDAY, DAY.TUESDAY, DAY.WEDNESDAY, DAY.THURSDAY, DAY.FRIDAY, DAY.SATURDAY, DAY.SUNDAY],
            label: "All days"
        },
        {
            value: [DAY.MONDAY, DAY.TUESDAY, DAY.WEDNESDAY, DAY.THURSDAY, DAY.FRIDAY],
            label: "All Weekdays"
        },
        {
            value: [DAY.SATURDAY, DAY.SUNDAY],
            label: "Weekends"
        },
        {
            value: [DAY.MONDAY],
            label: "Monday"
        },
        {
            value: [DAY.TUESDAY],
            label: "Tuesday"
        },
        {
            value: [DAY.WEDNESDAY],
            label: "Wednesday"
        },
        {
            value: [DAY.THURSDAY],
            label: "Thursday"
        },
        {
            value: [DAY.FRIDAY],
            label: "Friday"
        },
    ]
}];

export const COPY_SCHEDULE_OPTS_LABEL_STR = {
    ALL_CAMPAIGNS: "All Campaigns",
    ALL_CLICK_CAMPAIGNS: "All Click Campaigns",
    ALL_CALL_CAMPAIGNS: "All Call Campaigns",
    ALL_LEAD_CAMPAIGNS: "All Lead Campaigns",
}

export const copyScheduleOptions = [{
    options: [
        //TODO: Uncomment this when lead and call campaigns are live
        { value: [], label: COPY_SCHEDULE_OPTS_LABEL_STR.ALL_CAMPAIGNS, id: "1" },
        { value: [{ param: "product_type", value: "1" }], label: COPY_SCHEDULE_OPTS_LABEL_STR.ALL_CLICK_CAMPAIGNS, id: "2" },
        { value: [{ param: "product_type", value: "2" }], label: COPY_SCHEDULE_OPTS_LABEL_STR.ALL_CALL_CAMPAIGNS, id: "3" },
        { value: [{ param: "product_type", value: "3" }], label: COPY_SCHEDULE_OPTS_LABEL_STR.ALL_LEAD_CAMPAIGNS, id: "4" },
    ]
}];



export const optionsForCampaignByProductType = {
    [NAME_OF_PRODUCT_TYPES.CLICKS]: { label: 'All Click Campaigns', value: "all" },
    [NAME_OF_PRODUCT_TYPES.LEADS]: { label: 'All Lead Campaigns', value: "all" },
    [NAME_OF_PRODUCT_TYPES.CALLS]: { label: 'All Call Campaigns', value: "all" },
    [NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS]: { label: 'All Syndi Click Campaigns', value: 'all' },
    [NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS]: { label: 'All Quote Funnels Campaigns', value: 'all' },
}


export function getDropdownButtonLabelForCampaign({ _, value }) {
    const scheduleSelectedLabelAndValue = value.find((opt) => opt.value === "all");
    if (value && scheduleSelectedLabelAndValue?.value) {
        return <span className="css-1v99tuv text-black">{scheduleSelectedLabelAndValue?.label}</span>;
    } else if (value?.length === 0) {
        return `Select...`;
    }
    return <span className="css-1v99tuv text-black">{value?.length} selected</span>;
}

export const DEFAULT_CAMPAIGN_SCHEDULES = [
    {
        "modification_type": "new",
        "day_id": 0,
        "active": true,
        "h0": 100,
        "h1": 100,
        "h2": 100,
        "h3": 100,
        "h4": 100,
        "h5": 100,
        "h6": 100,
        "h7": 100,
        "h8": 100,
        "h9": 100,
        "h10": 100,
        "h11": 100,
        "h12": 100,
        "h13": 100,
        "h14": 100,
        "h15": 100,
        "h16": 100,
        "h17": 100,
        "h18": 100,
        "h19": 100,
        "h20": 100,
        "h21": 100,
        "h22": 100,
        "h23": 100
    },
    {
        "modification_type": "new",
        "day_id": 1,
        "active": true,
        "h0": 100,
        "h1": 100,
        "h2": 100,
        "h3": 100,
        "h4": 100,
        "h5": 100,
        "h6": 100,
        "h7": 100,
        "h8": 100,
        "h9": 100,
        "h10": 100,
        "h11": 100,
        "h12": 100,
        "h13": 100,
        "h14": 100,
        "h15": 100,
        "h16": 100,
        "h17": 100,
        "h18": 100,
        "h19": 100,
        "h20": 100,
        "h21": 100,
        "h22": 100,
        "h23": 100
    },
    {
        "modification_type": "new",
        "day_id": 2,
        "active": true,
        "h0": 100,
        "h1": 100,
        "h2": 100,
        "h3": 100,
        "h4": 100,
        "h5": 100,
        "h6": 100,
        "h7": 100,
        "h8": 100,
        "h9": 100,
        "h10": 100,
        "h11": 100,
        "h12": 100,
        "h13": 100,
        "h14": 100,
        "h15": 100,
        "h16": 100,
        "h17": 100,
        "h18": 100,
        "h19": 100,
        "h20": 100,
        "h21": 100,
        "h22": 100,
        "h23": 100
    },
    {
        "modification_type": "new",
        "day_id": 3,
        "active": true,
        "h0": 100,
        "h1": 100,
        "h2": 100,
        "h3": 100,
        "h4": 100,
        "h5": 100,
        "h6": 100,
        "h7": 100,
        "h8": 100,
        "h9": 100,
        "h10": 100,
        "h11": 100,
        "h12": 100,
        "h13": 100,
        "h14": 100,
        "h15": 100,
        "h16": 100,
        "h17": 100,
        "h18": 100,
        "h19": 100,
        "h20": 100,
        "h21": 100,
        "h22": 100,
        "h23": 100
    },
    {
        "modification_type": "new",
        "day_id": 4,
        "active": true,
        "h0": 100,
        "h1": 100,
        "h2": 100,
        "h3": 100,
        "h4": 100,
        "h5": 100,
        "h6": 100,
        "h7": 100,
        "h8": 100,
        "h9": 100,
        "h10": 100,
        "h11": 100,
        "h12": 100,
        "h13": 100,
        "h14": 100,
        "h15": 100,
        "h16": 100,
        "h17": 100,
        "h18": 100,
        "h19": 100,
        "h20": 100,
        "h21": 100,
        "h22": 100,
        "h23": 100
    },
    {
        "modification_type": "new",
        "day_id": 5,
        "active": true,
        "h0": 100,
        "h1": 100,
        "h2": 100,
        "h3": 100,
        "h4": 100,
        "h5": 100,
        "h6": 100,
        "h7": 100,
        "h8": 100,
        "h9": 100,
        "h10": 100,
        "h11": 100,
        "h12": 100,
        "h13": 100,
        "h14": 100,
        "h15": 100,
        "h16": 100,
        "h17": 100,
        "h18": 100,
        "h19": 100,
        "h20": 100,
        "h21": 100,
        "h22": 100,
        "h23": 100
    },
    {
        "modification_type": "new",
        "day_id": 6,
        "active": true,
        "h0": 100,
        "h1": 100,
        "h2": 100,
        "h3": 100,
        "h4": 100,
        "h5": 100,
        "h6": 100,
        "h7": 100,
        "h8": 100,
        "h9": 100,
        "h10": 100,
        "h11": 100,
        "h12": 100,
        "h13": 100,
        "h14": 100,
        "h15": 100,
        "h16": 100,
        "h17": 100,
        "h18": 100,
        "h19": 100,
        "h20": 100,
        "h21": 100,
        "h22": 100,
        "h23": 100
    }
]